import React from 'react'
import styles from './Style.module.css'

export const BtnLink = ({label, handleClick, disabled, title, customClass, type = "button"}) => {
  return (
    <button type={type} className={`${styles.BtnLink} btn ${customClass}`} onClick={handleClick} disabled={disabled} title={title}>
        {label}
    </button>
  )
}
